import { VeeValidate } from '../vue.bundle';

VeeValidate.Validator.extend('pwd', {
    getMessage: field => '*',
    validate: (value) => {
        let pattern = /(?=^.{8,20}$)((?=.*\d)(?=.*[A-Z])(?=.*[a-z])|(?=.*\d)(?=.*[^A-Za-z0-9])(?=.*[a-z])|(?=.*[^A-Za-z0-9])(?=.*[A-Z])(?=.*[a-z])|(?=.*\d)(?=.*[A-Z])(?=.*[^A-Za-z0-9]))^.*/;
        return pattern.test(value);
    }
});

export default {
    name: 'PasswordResetModule',
    template: '#cmp-password-reset',
    data() {
        return {
            token: null,
            password: '',
            passwordConfirm: '',
            showSuccess: false,
            showError: false,
            showErrorToken: false,
            showForm: false,
            submitting: false,
            requestVerificationToken: '',
            NonZDC: false,
            showPasswordInValid: false
        };
    },
    methods: {
        resetPassword() {
            let self = this;
            self.showPasswordInValid = false;
            self.$validator.validateAll().then((valid) => {
                if (valid) {
                    self.submitting = true;

                    let passwordReset = {
                        token: self.token,
                        password: self.passwordConfirm
                    };

                    $.ajax({
                        type: 'post',
                        url: '/api/password/reset',
                        dataType: 'json',
                        contentType: 'application/json',
                        data: JSON.stringify(passwordReset),
                        headers: { 'X-CSRF-TOKEN': self.requestVerificationToken }
                    })
                        .done((r) => {
                            if (r.valid) {
                                self.showForm = false;
                                self.showSuccess = true;
                            } else {
                                if (r.passwordInValid) {
                                    self.showPasswordInValid = true;
                                    self.submitting = false;
                                }
                                else {
                                    self.showErrorToken = true;
                                }
                            }
                        })
                        .fail(() => {
                            self.showError = true;
                            self.submitting = false;
                        });
                }
            });
        },  
        resetPasswordB2C() {
            let self = this;

            $.ajax({
                type: 'post',
                url: '/api/password/PasswordResetB2C',
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(''),
                headers: { 'X-CSRF-TOKEN': self.requestVerificationToken }
            })
                .done((r) => {
                    if (r.msg == 'B2CRedirect') {
                        self.showSuccess = false;
                        window.location.href = r.b2Curl;
                    }
                })
                .fail(() => {
                    self.showError = true;
                    self.submitting = false;

                });
        },
        validateToken() {
            let self = this;

            $.ajax({
                type: 'post',
                url: '/api/password/validate',
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(self.token),
                headers: { 'X-CSRF-TOKEN': self.requestVerificationToken }
            })
                .done((r) => {
                    if (r.valid) {
                        self.showForm = true;
                    } else {
                        self.showErrorToken = true;
                    }
                })
                .fail(() => {
                    self.showError = true;
                    self.submitting = false;
                });
        },
        setRequestVerificationToken() {
            this.requestVerificationToken = $('input[name=__RequestVerificationToken]').val();
        }
    },
    created() {
        let self = this;
        self.token = self.$route.params.token;
        self.setRequestVerificationToken();
        self.validateToken();
        toggleRegisterLoginMsg(false);
    }
}


// WEBPACK FOOTER //
// ./src/scripts/vue/components/PasswordReset.js